<template>
  <div id="meeting-form">
    <form v-on:submit.prevent>
      <label
        class="input-label"
        for="visitor"
        style="line-height: initial; margin-bottom: 8px; margin-top: 8px"
      >
        Visitors (you can add multiple email addresses separated by semicolon):
      </label>
      <input type="text" id="visitor" v-model="visitorHolder" />
      <button class="addVisitorBtn" type="button" @click="handleVisitors">
        Add Visitors
      </button>
      <div id="resend-email" style="max-height: 350px; overflow: auto;">
        <div v-for="(item, index) in visitors" :key="index">
          <div class="horiz-align-items" style="width: 80%; margin: auto">
            <div class="personImage-holder">
              <img class="personImage" src="../assets/profile-icon.png" />
            </div>
            <div class="vertical-align-items">
              <label class="user-email-text">{{ item }}</label>
            </div>
            <div class="button-holder">
              <button
                type="button"
                class="delete"
                @click="deleteFromVisitorList(index)"
              >
                Remove
              </button>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <button
        v-if="visitors.length > 0"
        class="createMeetingBtn"
        type="button"
        @click="sendInvitationToVisitors"
      >
        Confirm
      </button>
    </form>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
  name: "Visitors",
  props: ["meetingId"],
  data() {
    return {
      visitors: [],
      visitorHolder: "",
    };
  },
  methods: {
    ...mapActions(["inviteVisitors"]),
    ...mapMutations(["addVisitors", "toggleVisitorsModal"]),
    handleVisitors() {
      let temp = this.visitorHolder.split(";");
      console.log(temp);
      if (this.checkVisitorsEmail(temp)) {
        for (const item of temp) {
          this.visitors.push(item);
        }
        console.log(this.visitors);
        this.visitorHolder = "";
      } else {
        alert("Visitors emails are not correct!");
      }
    },
    deleteFromVisitorList(index) {
      this.visitors.splice(index, 1);
      console.log(this.visitors);
    },
    checkVisitorsEmail(emails) {
      if (emails.length > 0) {
        for (const item of emails) {
          if (!this.validEmail(item.trim())) {
            return false;
          }
        }
        return true;
      } else {
        return true;
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    sendInvitationToVisitors() {
      const currentMeetingId = this.$store.state.Meetings.meetingDisplay.meetingId;
      this.inviteVisitors({
        meetingId: currentMeetingId,
        emails: this.visitors,
      })
        .then((response) => {
          console.log(
            "Axios POST call finished with status: ",
            response.status
          );
          this.addVisitors(this.visitors, currentMeetingId);
          this.toggleVisitorsModal();
          this.visitors = [];
        })
        .catch((error) => {
          alert("Something went wrong!");
        });
    },
  },
};
</script>

<style lang="scss" scoped src="@/styles/style-modal.scss">
</style>